import React from "react";
import { Provider } from "react-redux";

import { ReactRootComponent } from "./platform/Layout";
import { RapPageContext, IRapPageContext, Services, RestClients, ServiceOptions } from "./platform/Context";
import { RapPageService } from "./platform/services/Page";
import { RapAuthenticationService } from "./platform/services/Authentication";
import { RestClientOptionsProviderService } from "./platform/services/RestClientOptionsProvider";
import { UhfApiClient } from "./contracts/swagger/_generated";
import { UhfRestClientName } from "./platform/RestClientBase";
import { PageActionTypes } from "./platform/components/Page/redux/PageActions";
import { TestActionTypes } from "./views/TestView/redux/TestActions";
import { AuthHandler } from "./platform/components/AuthHandler/AuthHandler";
import { IRapTelemetryService, RapTelemetryService } from "./platform/services/Telemetry";

import Shell from "./platform/components/Shell/Shell";
import createStore from "./platform/redux/CreateStore";
import ThemeProvider from "./platform/components/ThemeProvider/ThemeProvider";

import "./styling/_authloading.scss";

export interface IAppState {
    
}

class App extends React.Component<{}, IAppState> {
    private pageContext: IRapPageContext;
    private store: any;

    constructor(props: any) {
        super(props);
        this.state = {  };
        Services.add("IRapPageService", { serviceFactory: RapPageService });
        Services.add("IRapTelemetryService", { serviceFactory: RapTelemetryService, options: ServiceOptions.Persistant });
        Services.add("IRapAuthenticationService", { serviceFactory: RapAuthenticationService });
        Services.add("IRestClientOptionsProviderService", { serviceFactory: RestClientOptionsProviderService });

        RestClients.add(UhfRestClientName, { factory: UhfApiClient });

        this.pageContext = new RapPageContext(Services, RestClients);

        this.store = createStore(this.pageContext);
        this.store.dispatch({ type: PageActionTypes.InitPage });
        this.store.dispatch({ type: TestActionTypes.InitTestView });

        this.pageContext.getService<IRapTelemetryService>("IRapTelemetryService");
    }

    render() {
        return (
            <AuthHandler>
                <Provider store={this.store}>
                    <ReactRootComponent pageContext={this.pageContext}>
                        <ThemeProvider>
                            <Shell />
                        </ThemeProvider>
                    </ReactRootComponent>
                </Provider>
            </AuthHandler>
        );
    }
}
export default App;